/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".ec-video-modal{text-align:center}  .ec-video-modal .modal-dialog{max-width:none;display:inline-block}  .ec-video-modal .modal-header{background-color:#0080ff;line-height:1.25rem}  .ec-video-modal .modal-title{font-size:1.15rem;color:#fff}  .ec-video-modal .close-btn{background:transparent;border:0;outline:none;padding:0;cursor:pointer}  .ec-video-modal .close-btn span{font-size:1.8rem;color:#fff}  .ec-video-modal .modal-body .loading-container{background-color:#fff;display:-webkit-box;display:flex;-webkit-box-pack:center;justify-content:center;-webkit-box-align:center;align-items:center;padding-bottom:3em}  .ec-video-modal .modal-body .loading-container .loader{width:8em;height:8em}  .ec-video-modal .modal-body .loading-container,   .ec-video-modal .modal-body iframe{width:640px;height:425px}.player-wrap[_ngcontent-%COMP%]{height:425px}"];
export { styles as styles };
//# sourceMappingURL=ec-modal.component.scss.shim.ngstyle.js.map


//////////////////
// WEBPACK FOOTER
// ./ts/app/shared/ec-modal/ec-modal.component.scss.shim.ngstyle.js
// module id = 1293
// module chunks = 27 28 29